import {Injectable} from "@angular/core";

@Injectable()
export class RoleConstants{

  public SITE_ACCESS:string = "site_access";
  public VIEW_USER_ACCOUNTS:string = "view_user_account";
  public MODIFY_USER_ACCOUNT:string = "modify_user_account";
  public MODIFY_OPERATION:string = "modify_operations";
  public VIEW_REPORTS:string = "view_reports";
  public VIEW_OPERATION_DASHBOARD:string = "view_operation_dashboard";
  public VIEW_ALL_FCCS:string = "view_all_fccs";
  public MODIFY_FCCS:string = "modify_fccs";
  public MODIFY_LOCATIONS:string = "modify_locations";
  public MODIFY_CATEGORIES:string = "modify_categories";
  public MODIFY_MANIFEST:string = "modify_manifests";

}